export default {
  ERROR: '@k-share/stories/ERROR',
  STORY_GET: '@k-share/stories/STORY_GET',
  STORY_SET: '@k-share/stories/STORY_SET',
};
